import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useCounties = () => {
  const axios = useAxios();
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["counties"],
    queryFn: async () => {
      const urlKey = t("counties");
      const response = await axios.get(urlKey);
      return response.data?.data;
    },
    refetchOnWindowFocus: false
  });
};
